import styled from "styled-components";
import { IconTitleTextTooltipTextContainerBox } from "../../icon-title-text/boxes/text-container.box";

export const MessageBodyContainerBox = styled(IconTitleTextTooltipTextContainerBox)`
    ${({theme}) => theme.font.presets.regular};
 `;

 export const MessageBodyBoldContainerBox = styled.span`
    ${({theme}) => theme.font.presets.bold};
 `;
